export enum CallLogViolationEnum {
    Cancel = 1,
    Reject = 2,
}
